import type { ReactElement, ReactNode } from "react";
import type { PaymentsTab } from "../lib/payments-tabs";

export type PaymentsTabDef = {
  id: PaymentsTab;
  label: string;
  desc: string;
  icon: ReactNode;
};

/**
 * Glyphs for the Payments views. The in-page tab list that used to live here is
 * gone — the app sidebar lists these three as children of Payments, so the page
 * was rendering the same nav a second time beside it. The icons outlived it:
 * the sidebar's child rows and the mobile pill nav both wear them.
 */
export function OnlineTransactionsTabIcon(): ReactElement {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="5" width="20" height="14" rx="2.5" />
      <path d="M2 10h20" />
      <path d="M6 15h3" />
      <path d="M13 15h5" />
    </svg>
  );
}

/** Money in and money out — the Wallet-transactions tab's glyph. Kept local so
 *  it is not confused with the card mark above, which is the other direction:
 *  gateway money arriving from buyers. */
export function WalletActivityIcon(): ReactElement {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M17 3v14" />
      <path d="m21 13-4 4-4-4" />
      <path d="M7 21V7" />
      <path d="m3 11 4-4 4 4" />
    </svg>
  );
}

/** The Wallet tab's glyph — a smaller twin of the sidebar's wallet icon. */
export function WalletTabIcon(): ReactElement {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 7.5A2.5 2.5 0 0 1 5.5 5H18a2 2 0 0 1 2 2v1" />
      <rect x="3" y="7.5" width="18" height="12" rx="2.5" />
      <path d="M16 13.5h2.5" />
    </svg>
  );
}
